module.exports = __webpack_public_path__ + "img/73.3f253229.jpg";